import { bool, func, string } from 'prop-types'
import { forwardRef } from 'react'
import styled from 'styled-components'
import { Text, TextStyle } from '../Text'

export const InputText = forwardRef(({ label, error, required, description, errorHint, ...props }, ref) => {
  return (
    <Wrap>
      {label && (
        <Label>
          {label}
          {required && ' *'}
        </Label>
      )}
      {description && <Description>{description}</Description>}
      <Input {...props} ref={ref} />
      {error && <Text color="primary">{error}</Text>}
      {errorHint && (
        <ErrorHint>
          <Text color="white">{errorHint}</Text>
        </ErrorHint>
      )}
    </Wrap>
  )
})

InputText.displayName = 'InputText'
InputText.propTypes = {
  label: string,
  onChange: func,
  onBlur: func,
  onFocus: func,
  error: string,
  required: bool,
  description: string,
  errorHint: string,
}

const Wrap = styled.div`
  margin-bottom: 1.5rem;
  position: relative;
  &:last-child {
    margin-bottom: 0;
  }
`

export const Input = styled.input`
  ${TextStyle}
  font-family: var(--font-family-secondary);
  padding: 0.75rem;
  width: 100%;
  outline: none;
  display: block;
  ${({ noBorder }) => !noBorder && `border: 1px solid var(--color-dark-gray);`}
  ${({ noBorder }) => noBorder && `border: 0;`}
`

export const Label = styled.label`
  ${TextStyle}
  margin-bottom: 0.75rem;
  display: block;

  &:has(+ small) {
    margin-bottom: 0;
  }
`

const ErrorHint = styled.div`
  position: absolute;
  bottom: calc(100% + 10px);
  left: 5px;
  right: 5px;
  margin: auto;
  padding: 5px;
  background-color: var(--color-primary);
  max-width: 250px;

  &::after {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5px 10px 0 10px;
    border-color: var(--color-primary) transparent transparent transparent;
    position: absolute;
    top: 100%;
    display: block;
    content: '';
    margin: auto;
    left: -10px;
    right: 0;
  }
`

const Description = styled.small`
  margin-bottom: 0.75rem;
  display: block;
  opacity: 0.7;
`
